import React from "react";
import { addUser, updateUser } from "../../utils/api";

function UserFormModal({
  show,
  onClose,
  mode = "create", // "create" or "update"
  form,
  setForm,
  editingId,
  refresh,
  setBanner,
}) {
  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res;
      if (mode === "create") {
        res = await addUser(form);
      } else {
        res = await updateUser({ id: editingId, ...form });
      }

      if (res.success) {
        setBanner({
          type: "success",
          message:
            res.message ||
            (mode === "create"
              ? "User created successfully!"
              : "User updated successfully!"),
        });
        refresh();
        onClose();
        // ✅ Reset form after success
        setForm({
          name: "",
          username: "",
          email: "",
          role: "user",
          password: "",
        });
      } else {
        setBanner({
          type: "danger",
          message: res.message || "Operation failed. Please try again.",
        });
      }
    } catch (err) {
      console.error("User form submit error:", err);
      setBanner({
        type: "danger",
        message: "Server error. Please try again later.",
      });
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {mode === "create" ? "Add New User" : "Update User"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.username}
                  onChange={(e) =>
                    setForm({ ...form, username: e.target.value })
                  }
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  value={form.role}
                  onChange={(e) => setForm({ ...form, role: e.target.value })}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              {mode === "create" && (
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={form.password}
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                    required
                  />
                </div>
              )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {mode === "create" ? "Create" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserFormModal;
